module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/feature_6-45a00a2c363948ad4f44d0ee13f60767.png";